/**
 * window.__MSS_FE__ 객체에 안전하게 접근하는 유틸 함수
 * 각 프로젝트의 global.d.ts에 정의된 타입을 자동으로 읽음
 *
 * @example
 * const config = getMSSFE('config');
 * config?.couponPrice  // ✅ 프로젝트 global.d.ts 타입 자동완성
 */
export const getMSSFE = <K extends keyof NonNullable<Window['__MSS_FE__']>>(
  key: K,
): NonNullable<Window['__MSS_FE__']>[K] | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.__MSS_FE__?.[key];
};
